<script>
import { capitalize } from '_utils';
import PuzzleService from '_services/rest/modules/puzzle';
import { createResettableCellFields, CELL_HEIGHT } from './PuzzleModel';

const QUESTION_CHAR_BUDGET_RATIO = 0.5;
const FULL_CELL_QUESTION_CHARS = CELL_HEIGHT * QUESTION_CHAR_BUDGET_RATIO;
const HALF_COLUMN_QUESTION_CHARS = FULL_CELL_QUESTION_CHARS / 2;

export default {
  name: 'puzzle-fill-table',
  data() {
    return {
      respo: false,
      valid: false,
    };
  },
  computed: {},
  methods: {
    getCellIndex(cell) {
      // const index = this.model.table.findIndex(item => item.positionx === cell.positionx && item.positiony === cell.positiony);
      // return index;
      let { positiony } = cell;
      if (Number.isNaN(Number(positiony))) {
        [positiony] = positiony.split('_');
      }
      const diff = parseInt(positiony, 10) > 0 ? 10 - this.model.columns : 0;
      const index =
        parseInt(positiony, 10) * 10 +
        parseInt(cell.positionx, 10) -
        parseInt(positiony, 10) * diff;
      return index;
    },
    getInitialCell(optionSelected) {
      if (['right', 'bottom'].includes(optionSelected)) {
        return 1;
      }
      if (['left', 'top'].includes(optionSelected)) {
        return -1;
      }

      return 0;
    },
    incrementInitialPosition(
      index,
      directions,
      start = 1,
      sequence = this.model.columns,
    ) {
      // TODO :: Refactoring merge incrementInitialPosition and decrementInitialPosition
      const size = directions.length;

      let initial = [1, 3].includes(size) ? index + start : index;
      let rowspan =
        this.model.table[index].type.indexOf('rowspan') > -1 &&
        directions.includes('bottom')
          ? 2
          : 1;

      if (size > 1) {
        initial += sequence * rowspan * this.getInitialCell(directions[1]);
      }

      if (size === 3) {
        rowspan = directions.includes('secondRow') ? start : rowspan;
        initial += sequence * rowspan * this.getInitialCell(directions[2]);
      }

      if (size === 1 && this.model.table[initial].hide) {
        initial += start;
      }
      return initial;
    },
    decrementInitialPosition(index, directions, rows = 0, childIndex = false) {
      const size = directions.length;
      let initial = [1, 3].includes(size)
        ? parseInt(index, 10) + parseInt(rows, 10)
        : parseInt(index, 10);
      const rowspan =
        this.model.table[index].type.includes('rowspan') &&
        directions.includes('bottom')
          ? 2
          : 1;

      if (size > 1) {
        initial += this.getInitialCell(directions[1]) * rowspan;
      }

      if (size === 3) {
        initial += this.getInitialCell(directions[2]) * rowspan;
      }

      if (size === 1 && this.model.table[initial].hide) {
        initial += rows;
      }
      if (childIndex && Number.isNaN(Number(childIndex))) {
        const child = childIndex.split('_')[0];
        const active = this.getActiveCell(index);
        if (
          this.model.table[index].children[child].type === 'colspan_col' &&
          active === 1
        ) {
          initial += 1;
        }
      }
      return initial;
    },
    getActiveCell(index) {
      return this.model.table[index].children.findIndex(item => {
        if (item.active) return true;
        if (item.children.length > 0) {
          return item.children.findIndex(child => child.active);
        }
        return false;
      });
    },
    checkIfAnswerFitInRow(index, numberOfAnswerChar) {
      const position = this.model.table[index].positionx + numberOfAnswerChar;
      if (position < 0 || position > this.model.columns) {
        this.activeAlert({
          message: this.$t('puzzle.alert.wordTooLong'),
          theme: 'danger',
        });
        return false;
      }
      return true;
    },
    checkIfAnswerFitInTable(index, numberOfAnswerChar) {
      const position = index + numberOfAnswerChar;
      if (!this.model.table[position]) {
        this.activeAlert({
          message: this.$t('puzzle.alert.wordTooLong'),
          theme: 'danger',
        });
        return false;
      }
      return true;
    },
    checkIfHasOtherAnswer(position) {
      const { answer: cellAnswer } = this.model.table[position];
      if (!cellAnswer || cellAnswer.answer !== null) {
        // TODO :: Refactoring the confirm to confirmation-modal
        // eslint-disable-next-line
        this.respo = confirm(this.$t('puzzle.confirm.overwriteAnswer'));
        return this.respo;
      }
      return true;
    },
    loopTopAnswer(initial, callback) {
      let next = initial;
      while (
        this.model.table[next].isAnswer &&
        this.model.table[next].positionx === this.model.table[initial].positionx
      ) {
        callback(this.model.table[next]);
        next -= parseInt(this.model.columns, 10);
        if (next <= 0) break;
      }
    },
    loopBottomAnswer(initial, callback) {
      let next = initial;
      while (
        this.model.table[next].isAnswer &&
        this.model.table[next].positionx === this.model.table[initial].positionx
      ) {
        callback(this.model.table[next]);
        next += parseInt(this.model.columns, 10);
        if (next >= this.model.table.length) break;
      }
    },
    loopRightAnswer(initial, callback) {
      let next = initial;
      while (
        this.model.table[next].isAnswer &&
        this.model.table[next].positiony === this.model.table[initial].positiony
      ) {
        callback(this.model.table[next]);
        next += 1;
        if (next >= this.model.table.length) break;
      }
    },
    loopLeftAnswer(initial, callback) {
      let next = initial;
      while (
        this.model.table[next].isAnswer &&
        this.model.table[next].positiony === this.model.table[initial].positiony
      ) {
        callback(this.model.table[next]);
        next -= 1;
        if (next <= 0) break;
      }
    },
    getCellAnswer(index, childIndex = null) {
      if (childIndex !== null) {
        if (Number.isNaN(Number(childIndex))) {
          const [child, grandson] = childIndex.split('_');
          return this.model.table[index].children[child].children[grandson];
        }
        return this.model.table[index].children[childIndex];
      }
      return this.model.table[index];
    },
    getImmediateParentCell(cell) {
      const { index, childIndex } = this.getIndexCellValue(cell);
      if (childIndex == null) {
        return null;
      }
      if (Number.isNaN(Number(childIndex))) {
        const [child] = String(childIndex).split('_');
        return this.model.table[index].children[child];
      }
      return this.model.table[index];
    },
    isSameRelatedQuestion(a, b) {
      return a.id === b.id && a.child === b.child;
    },
    buildRelatedQuestionEntry(index, childIndex) {
      const parent = this.model.table[index];
      if (childIndex === null) {
        return { id: parent.id, child: null };
      }

      const firstLevelIndex = Number.isNaN(Number(childIndex))
        ? Number(String(childIndex).split('_')[0])
        : Number(childIndex);

      const child = parent.children?.[firstLevelIndex];
      let childId = child?.id;

      if (!childId && parent.id != null) {
        childId = `${parent.id}-child-${firstLevelIndex}`;
        if (child) child.id = childId;
      }

      return { id: parent.id, child: childId };
    },
    appendRelatedQuestion(cell, entry) {
      const list = cell.related_questions || [];
      if (list.some(item => this.isSameRelatedQuestion(item, entry))) return;
      cell.related_questions = list.concat(entry);
    },
    unlinkRelatedQuestionEntry(entry) {
      if (!entry || !entry.id) return;

      this.model.table.forEach(cell => {
        if (!cell.related_questions || !cell.related_questions.length) return;
        const next = cell.related_questions.filter(
          item => !this.isSameRelatedQuestion(item, entry),
        );
        cell.related_questions = next.length ? next : null;
      });
    },
    linkRelatedQuestions(index, childIndex, letterCells) {
      const parent = this.model.table[index];
      if (!parent.id) {
        parent.id = `cell-${parent.positiony}-${parent.positionx}`;
      }

      const entry = this.buildRelatedQuestionEntry(index, childIndex);
      if (!entry.id) return;

      this.unlinkRelatedQuestionEntry(entry);
      letterCells.forEach(cell => this.appendRelatedQuestion(cell, entry));
    },
    unlinkRelatedQuestionsForCell(cell) {
      const { index, childIndex } = this.getIndexCellValue(cell);
      const entry = this.buildRelatedQuestionEntry(index, childIndex);
      this.unlinkRelatedQuestionEntry(entry);

      const target = this.getCellAnswer(index, childIndex);
      if (!target) return;
      Object.assign(target, createResettableCellFields());
    },
    topAnswer(index, directions, childIndex = null) {
      const initial = this.decrementInitialPosition(
        index,
        directions,
        -this.model.columns,
      );
      let word = '';
      const letterCells = [];
      this.loopTopAnswer(initial, cell => {
        word += cell.text;
        letterCells.push(cell);
      });
      word = word.split('').reverse().join('');
      this.linkRelatedQuestions(index, childIndex, letterCells);
      this.saveAnswer(index, childIndex, word).then(() => {
        this.loopTopAnswer(initial, cell => {
          cell.updated = true;
        });
      });
      return true;
    },
    bottomAnswer(index, directions, childIndex = null) {
      const initial = this.decrementInitialPosition(
        index,
        directions,
        this.model.columns,
        childIndex,
      );
      let word = '';
      const letterCells = [];
      this.loopBottomAnswer(initial, cell => {
        word += cell.text;
        letterCells.push(cell);
      });
      this.linkRelatedQuestions(index, childIndex, letterCells);
      this.saveAnswer(index, childIndex, word).then(() => {
        this.loopBottomAnswer(initial, cell => {
          cell.updated = true;
        });
      });
      return true;
    },
    leftAnswer(index, directions, childIndex = null) {
      const initial = this.incrementInitialPosition(index, directions, -1);
      let word = '';
      const letterCells = [];
      this.loopLeftAnswer(initial, cell => {
        word += cell.text;
        letterCells.push(cell);
      });
      word = word.split('').reverse().join('');
      this.linkRelatedQuestions(index, childIndex, letterCells);
      this.saveAnswer(index, childIndex, word).then(() => {
        this.loopLeftAnswer(initial, cell => {
          cell.updated = true;
        });
      });
      return true;
    },
    rightAnswer(index, directions, childIndex = null) {
      const initial = this.incrementInitialPosition(
        index,
        directions,
        1,
        this.model.columns,
      );
      let word = '';
      const letterCells = [];
      this.loopRightAnswer(initial, cell => {
        word += cell.text;
        letterCells.push(cell);
      });
      this.linkRelatedQuestions(index, childIndex, letterCells);
      this.saveAnswer(index, childIndex, word).then(() => {
        this.loopRightAnswer(initial, cell => {
          cell.updated = true;
        });
      });
      return true;
    },
    saveAnswer(index, childIndex, word) {
      const answer = { id: null, answer: capitalize(word) };
      return PuzzleService.saveAnswer(answer).then(response => {
        const cell = this.getCellAnswer(index, childIndex);
        if (!cell) return response;
        cell.answer = response;
        cell.direction_id = cell.direction?.id ?? null;
        cell.updated = true;
        this.setQuestionIfHasOneOrMore(response, cell);
        if (cell.direction?.slug) this.setArrowInCell(cell);
        return response;
      });
    },
    getPositionArrowByAnswer(direction) {
      const directions = direction.split('_');
      if (directions.length > 2) {
        return direction;
      }
      return directions.pop();
    },
    setArrowInCell(cell) {
      const position = this.getPositionArrowByAnswer(cell.direction.slug);
      const [arrowPosition] = this.$store.state.puzzle.arrowPositions.filter(
        item =>
          JSON.stringify(position.split('_').sort()) ===
          JSON.stringify(item.slug.split('_').sort()),
      );
      cell.arrow_position = arrowPosition;
      cell.arrow_position_id = arrowPosition.id;

      const first = cell.direction.slug.split('_').shift();
      const [arrowDirection] = this.$store.state.puzzle.arrowDirections.filter(
        dir => dir.slug === first,
      );
      cell.arrow_direction = arrowDirection;
      cell.arrow_direction_id = arrowDirection.id;
    },
    pickBestQuestion(questions, maxChars) {
      const getLength = question => (question.question || '').length;
      const fitting = questions.filter(q => getLength(q) <= maxChars);

      if (fitting.length) {
        return fitting.reduce((longest, question) =>
          (getLength(question) > getLength(longest) ? question : longest),
        );
      }

      return questions.reduce((shortest, question) =>
        (getLength(question) < getLength(shortest) ? question : shortest),
      );
    },
    getQuestionCharBudget(cell) {
      const parent = this.getImmediateParentCell(cell);

      if (parent && parent.type === 'colspan_col') {
        return HALF_COLUMN_QUESTION_CHARS;
      }

      const heightPercent = cell.height || CELL_HEIGHT;
      return (heightPercent / CELL_HEIGHT) * FULL_CELL_QUESTION_CHARS;
    },
    setQuestionIfHasOneOrMore(answer, cell) {
      if (!answer.questions || answer.questions.length === 0) {
        return;
      }
      const maxChars = this.getQuestionCharBudget(cell);
      cell.question = this.pickBestQuestion(answer.questions, maxChars);
      cell.question_id = cell.question.id;
      cell.text = cell.question.question;
    },
  },
};
</script>
